export type GetCookieArg = Record<'name', 'cp' | 'awin'>

export type Cookie = {
  commissionGroup: CommissionGroup
  channel: string
  awc: string | null
  voucher: string
}

export type CustomerJourneyCookieResult = {
  data: Cookie | null
  message: string
}

export type ClearCustomerJourneyCookieResult = {
  message: string
}

export enum ChannelValue {
  awin = 'aw',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  ppcBrand = 'aw',
  ppcGeneric = 'ppc',
  facebook = 'fb',
  tiktok = 'tiktok',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  direct = 'aw',
}

export type ChannelKeys =
  | 'awin'
  | 'ppcBrand'
  | 'ppcGeneric'
  | 'facebook'
  | 'tiktok'
  | 'direct'

export type ChannelConditions = {
  channelName: ChannelKeys
  priority: number
  condition: boolean
  channelValue: ChannelValue
}

export type CommissionGroup = 'DEFAULT' | 'EV' | 'SERVICING'
